import { getOccupancy } from 'modules/selectors/here_now_users';
import {
	getStateOfGame,
	getTimeToAnswer,
	getTriviaAnswerSelector,
	getTriviaQuestionResultSelector,
	getTriviaQuestionToDisplay,
	getTriviaUserAnswerSelector,
	isShowPointsBadge
} from 'modules/selectors/trivia';
import { getUser } from 'modules/selectors/user';
import { EnumTriviaStatesOfGame } from 'modules/utils/enums';
import { useSelector } from 'react-redux';


export const useUsersStats = () => {
	const occupancy = useSelector(getOccupancy);
	const state_of_game = useSelector(getStateOfGame);
	const is_joining = state_of_game === EnumTriviaStatesOfGame.before_game;

	return {
		occupancy,
		is_joining
	}
};

export const useQuestionSelectors = () => {
	const question = useSelector(getTriviaQuestionToDisplay);

	return {
		users_answer: useSelector(getTriviaUserAnswerSelector)(question.id),
		correct_answers: useSelector(getTriviaAnswerSelector)(question.id),
		question_result: useSelector(getTriviaQuestionResultSelector)(question.id),
		user: useSelector(getUser),
		is_show_points_badge: useSelector(isShowPointsBadge),
		time_to_answer: useSelector(getTimeToAnswer),
		question
	};
};

export const useScrollToID = (id: string) => {
	return () => {
		const elem = document.getElementById(id);
		setTimeout(() => {
			if (elem) {
				elem.scrollIntoView({
					block: 'center',
					behavior: 'smooth'
				});
			}
		}, 100);
	}
}
